import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilsMapPipe } from './utils-map.pipe';

@NgModule({
  declarations: [UtilsMapPipe],
  exports: [UtilsMapPipe],
  imports: [CommonModule]
})
export class UtilsMapModule {}
